export default __webpack_public_path__ + "static/Why Chinese Picture Books Are Powerful Learning Tools-8cf96bea4e6c2e5f9682c49479ff743e.png";